// source: pbtypes/gen/scan_planner/long_range_explore_replan_state.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_eigen_lcm_Vector3f_pb = require('../../../pbtypes/gen/eigen_lcm/Vector3f_pb.js');
goog.object.extend(proto, pbtypes_gen_eigen_lcm_Vector3f_pb);
goog.exportSymbol('proto.scan_planner.LongRangeExploreReplanState', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scan_planner.LongRangeExploreReplanState = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scan_planner.LongRangeExploreReplanState, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scan_planner.LongRangeExploreReplanState.displayName = 'proto.scan_planner.LongRangeExploreReplanState';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scan_planner.LongRangeExploreReplanState.prototype.toObject = function(opt_includeInstance) {
  return proto.scan_planner.LongRangeExploreReplanState.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scan_planner.LongRangeExploreReplanState} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scan_planner.LongRangeExploreReplanState.toObject = function(includeInstance, msg) {
  var f, obj = {
initialized: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
startPosition: (f = msg.getStartPosition()) && pbtypes_gen_eigen_lcm_Vector3f_pb.Vector3fPb.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scan_planner.LongRangeExploreReplanState}
 */
proto.scan_planner.LongRangeExploreReplanState.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scan_planner.LongRangeExploreReplanState;
  return proto.scan_planner.LongRangeExploreReplanState.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scan_planner.LongRangeExploreReplanState} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scan_planner.LongRangeExploreReplanState}
 */
proto.scan_planner.LongRangeExploreReplanState.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setInitialized(value);
      break;
    case 2:
      var value = new pbtypes_gen_eigen_lcm_Vector3f_pb.Vector3fPb;
      reader.readMessage(value,pbtypes_gen_eigen_lcm_Vector3f_pb.Vector3fPb.deserializeBinaryFromReader);
      msg.setStartPosition(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scan_planner.LongRangeExploreReplanState.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scan_planner.LongRangeExploreReplanState.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scan_planner.LongRangeExploreReplanState} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scan_planner.LongRangeExploreReplanState.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInitialized();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getStartPosition();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      pbtypes_gen_eigen_lcm_Vector3f_pb.Vector3fPb.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool initialized = 1;
 * @return {boolean}
 */
proto.scan_planner.LongRangeExploreReplanState.prototype.getInitialized = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.scan_planner.LongRangeExploreReplanState} returns this
 */
proto.scan_planner.LongRangeExploreReplanState.prototype.setInitialized = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional eigen_lcm.Vector3fPb start_position = 2;
 * @return {?proto.eigen_lcm.Vector3fPb}
 */
proto.scan_planner.LongRangeExploreReplanState.prototype.getStartPosition = function() {
  return /** @type{?proto.eigen_lcm.Vector3fPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_eigen_lcm_Vector3f_pb.Vector3fPb, 2));
};


/**
 * @param {?proto.eigen_lcm.Vector3fPb|undefined} value
 * @return {!proto.scan_planner.LongRangeExploreReplanState} returns this
*/
proto.scan_planner.LongRangeExploreReplanState.prototype.setStartPosition = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.scan_planner.LongRangeExploreReplanState} returns this
 */
proto.scan_planner.LongRangeExploreReplanState.prototype.clearStartPosition = function() {
  return this.setStartPosition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scan_planner.LongRangeExploreReplanState.prototype.hasStartPosition = function() {
  return jspb.Message.getField(this, 2) != null;
};


goog.object.extend(exports, proto.scan_planner);
